<template>
  <div id="questionview">
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <h1>Questions Admin</h1>
      </v-row>
    </v-container>
    <div>
      <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
   <div class="mb-4 qr-buttons">
   
  <v-btn
    color="primary"
    class="mr-2"
    
    @click="onDockerQrClick"
  >
    Docker QR
  </v-btn>

  <v-btn
    color="primary"
    
    @click="onBillboardQrClick"
  >
    Billboard QR
  </v-btn>
</div>
    <div class="filtersub">
       
       <div class="first">
        <!-- 
         <v-select
          :items="categorylist"
           v-model="category"
           label="Select Category"
           item-text="primary_category"
           item-value="id"
           outlined></v-select>
           -->
           <v-text-field  v-model="questionids"  label="Question number(comma seperated)" class="mx-4 searchplayer"></v-text-field> 
       </div>
       
       <div class="second">
        <v-text-field  v-model="search"  label="Type Question or option(answers)" class="mx-4 searchplayer"></v-text-field> 
       </div> 
       <div class="third">
           <v-btn color="primary text-center" @click.prevent="searchdata">Search</v-btn>
       </div>
    </div>
    <!--  :search="search"  -->
     <v-data-table 
       :headers="headers" 
       :mobile-breakpoint="0" 
       :items="itemsWithSno"  
      
       hide-default-footer  
       disable-pagination>
       <template v-slot:item="{ item }"  >
         <tr :class="item.color">
          <td>{{ item.id }}</td>
          <td class="text-left">
            {{ item.question }}
            <div class="options">
              <div v-if="item.option_a">A. {{item.option_a}}</div> 
              <div v-if="item.option_b">B. {{item.option_b}}</div>
              <div v-if="item.option_c">C. {{item.option_c}}</div>
              <div v-if="item.option_d">D. {{item.option_d}}</div>
            </div>
          </td>
          <td><v-icon small class="mr-2" @click="editItem(item,item.keyval)">mdi-pencil</v-icon></td>
          <td><v-icon small class="mr-2" @click="questionstats(item.id)">mdi-message-text</v-icon></td>
          <td>
            <input 
            type="checkbox" 
            :checked="item.is_qrcode" 
            @change="updateCheckbox(item.id, 'qrcode', $event.target.checked ? 1 : 0,item.keyval)"
          />
            </td>
          <td>
            <input 
            type="checkbox" 
            :checked="item.is_special" 
            @change="updateCheckbox(item.id, 'special', $event.target.checked ? 1 : 0,item.keyval)"
          />
          </td>
           <td>
            <input 
            type="checkbox" 
            :checked="item.billboard_qr" 
            @change="updateCheckbox(item.id, 'billboard_qr', $event.target.checked ? 1 : 0,item.keyval)"
          />
          </td>
        </tr>
      </template>   
     </v-data-table>
     <infinite-loading  @infinite="getList"></infinite-loading>
    </div>
    <v-dialog v-model="dialog" max-width="650px">
     <v-card>
      <v-card-title>
        <span>Edit Question</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-text-field v-model="editedItem.question" label="Question"></v-text-field>
            </v-col>
          </v-row>
           <div class="d-flex radio-single-sec">
              <div class="first">Correct Answer</div>
              <div class="second">Options</div>
            </div>
          <div class="optionshere">
           <v-radio-group v-model="optionval">
            <div class="d-flex radio-single-sec">
              <div class="first"><v-radio value="A"></v-radio></div>
              <div class="second" >
                <v-text-field v-model="editedItem.option_a" label="Option A"></v-text-field>
              </div> 
            </div>    
            <div class="d-flex radio-single-sec">
              <div class="first"><v-radio value="B"></v-radio></div>
              <div class="second" >
                  <v-text-field v-model="editedItem.option_b" label="Option B"></v-text-field>
              </div>
            </div>    
            <div class="d-flex radio-single-sec">
              <div class="first"><v-radio value="C"></v-radio></div>
              <div class="second" >
                  <v-text-field v-model="editedItem.option_c" label="Option C"></v-text-field>
              </div>
            </div>    
            <div class="d-flex radio-single-sec">
              <div class="first"><v-radio value="D"></v-radio></div>
              <div class="second" >
                  <v-text-field v-model="editedItem.option_d" label="Option D"></v-text-field>
              </div>
            </div>
            </v-radio-group> 
          </div>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
        <v-btn color="blue darken-1" text @click="save">Save</v-btn>
      </v-card-actions>
     </v-card>
    </v-dialog>
  </div>  

</template>
<script>
export default {
  name: "Questionview",
  data() {
  return {
    mobileBreakpoint: 600,
    dialog:false,
    error: false,
    errorText:'',
    desserts:[],
    editedItem: {},        // <-- object, not array
    search:'', 
    page:1,
    categorylist:'',
    category:'',
    overlay: false,
    optionval:'',
    questionids:'',
     editedIndex: -1, 
  };
},
  computed: {
     headers(){
        let headers = [
              { text:"#", value: "sno" },
              { text:"Question  ",align: "question",value: "question",sortable: true},
              { text:"Action", value: "", },
              { text:"Stats", value: "", },
              { text:"QR code", value: "", },
              { text:"Special QR", value: "", },
              { text:"billboard QR", value: "", },
         ]
         return headers
      },
       itemsWithSno() {
          return this.desserts.map((d, index) => ({ ...d, sno: index + 1,keyval:index }))
       },
         hasDockerQr() {
    // show button if any item has is_qrcode > 0
    return this.desserts.some(d => Number(d.is_qrcode) > 0);
  },

  hasBillboardQr() {
    // show button if any item has billboard_qr > 0
    return this.desserts.some(d => Number(d.billboard_qr) > 0);
  }
  },
  created(){
     this.getCategories();
  },
  methods: {
    close(){
       this.editedItem = [];
       this.dialog     = false;
    },  
    save(){
      var questionid = this.editedItem.id;
      var question   = this.editedItem.question;
      var optiona    = this.editedItem.option_a;
      var optionb    = this.editedItem.option_b;
      var optionc    = this.editedItem.option_c;
      var optiond    = this.editedItem.option_d;
      this.desserts[this.editedIndex].answer = this.optionval;
      this.desserts[this.editedIndex].question = question;
      this.desserts[this.editedIndex].option_a = optiona;
      this.desserts[this.editedIndex].option_b = optionb;
      this.desserts[this.editedIndex].option_c = optionc;
      this.desserts[this.editedIndex].option_d = optiond;

      this.$store.dispatch("updateQuestion",
        {
          "id":questionid,"question":question,
          "optiona":optiona,
          "optionb":optionb,
          "optionc":optionc,
          "optiond":optiond,
          "answer" :this.optionval,
        }).then(() => {
         this.dialog = false;
      });
    },
    editItem(item,keyval){
       this.editedItem = item;
       this.optionval  = this.editedItem.answer;
       this.editedIndex = keyval;
       this.dialog     = true;
    },
    questionstats(questionid)
    {
        this.$router.push('/admin/questionstats/'+questionid);
    },
    searchdata(){
       var parameter = "";
       if(this.questionids != '')
       {
         parameter = parameter+"questionids="+this.questionids;
       }

       if(this.search != '')
       {
         parameter = parameter+"&question_string="+this.search;
       } 
       this.overlay = true;
       //this.desserts = [];
       this.$store.dispatch("getQuestionsList",{paramters:parameter}).then((response) => 
       {
          this.desserts = response.data;
          this.overlay = false;
       });
    }, 
    getList($state)
    {
       var parameter = "page="+this.page;
       if(this.category != '')
       {
         parameter = parameter+"&category_d="+this.category;
       }

       if(this.search != '')
       {
         parameter = parameter+"&question_string="+this.search;
       } 
       
       this.$store.dispatch("getQuestionsList",{paramters:parameter}).then((response) => {
          if(response.data.length > 0)
          {
             this.page += 1;
             this.desserts.push(...response.data);
             $state.loaded();
          }
          else
          {
            $state.complete();
          }
       });
     },
     getCategories(){
       this.$store.dispatch("getQuestionCategories").then((response) => {
          this.categorylist = response.data;
       });
     },
      updateCheckbox(id, field, value, keyval) {
    // call server
    this.$store.dispatch('updateQr', { id: id, field: field, value: value })
      .then(() => {
        // map API field -> local property name
        const propMap = {
          qrcode: 'is_qrcode',
          special: 'is_special',
          billboard_qr: 'billboard_qr'
        };
        const propName = propMap[field] || field;

        // If you got a valid index from the template, update that index directly
        if (typeof keyval === 'number' && keyval >= 0 && keyval < this.desserts.length) {
          // keep other props intact — create merged object then set it
          const merged = Object.assign({}, this.desserts[keyval], { [propName]: value });
          this.$set(this.desserts, keyval, merged);
        } else {
          // fallback: find by id (normalize to string for safety)
          const idx = this.desserts.findIndex(d => String(d.id) === String(id));
          if (idx !== -1) {
            const merged = Object.assign({}, this.desserts[idx], { [propName]: value });
            this.$set(this.desserts, idx, merged);
          }
        }

        // optional: if API returns updated object, you could merge that instead:
        // if (response && response.data) {
        //   // merge response.data into this.desserts[idx]
        // }

      })
      .catch(err => {
        console.error('updateQr failed', err);
        // optionally revert checkbox UI or show error
      });
  },
 

  onDockerQrClick() {
     const base = 'https://api.quizstar.online/generate-pdf';
      window.open(base, '_blank', 'noopener');
  },

  onBillboardQrClick() {
    const base = 'https://api.quizstar.online/generate-board';
     window.open(base, '_blank', 'noopener');
  }
  }
};
</script>
<style scoped>
.options {
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
    margin-bottom: 8px;
}
.radio-single-sec {align-items: center;}
.filtersub{display:flex; width:98%;margin:auto;align-items: center;}
.filtersub div.first{flex: 0 0 25%}
.filtersub div.second{flex: 0 0 65%}
.filtersub div.third{flex: 0 0 10%}
.radio-single-sec .first {flex: 0 0 15%;}
.radio-single-sec .second {flex: 0 0 85%;}
.qr-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-bottom: 16px;
  align-items: center;
}
.qr-buttons .v-btn {
  text-transform: uppercase;
  letter-spacing: 0.6px;
}
</style>